import React, { useContext, useRef, useState, useEffect } from 'react'
import PlayButton from '../../components/button/playButton';
import Modal from '../../components/Modal/Modal';
import { AudioHandler } from '../../Apihander/AudioRecording/AudioRecording';
import { errorToast, successToast } from "../../utils/notificationUtils";
import SidebarContext from '../../contexts/MyContext';
// import { useForm } from 'react-hook-form';
import { formatTimeInHHMMSS, formatTimeWithOptionalHours, timeStringToSeconds, formatTime } from '../../utils/timeFile'
import { generateRandomNumber } from '../../utils/generateRandomNumber';
import { AudioRecorder, useAudioRecorder, } from 'react-audio-voice-recorder';
import RecordingNote from '../../components/RecordingFeatures/RecordingNote';
import { Icon } from '@iconify/react';
import '../../css/app/recorder.css';



const Record = ({ elapsedTime, btntoggl, setBtnToggl, pauseRecording, stopRecording, load, setLoading, note, onNoteChange }) => {
    const { user, setTabIndex, selectedFormat, setFilterAudioData, recordNew, setRecordNew } = useContext(SidebarContext);

    const isLive = !(!recordNew || btntoggl);

    return (
        <>
            <div className="container vr-rec-legacy">
                <div className="vr-rec-legacy-inner">
                    <div>
                        <div className={`vr-rec-legacy-stage ${isLive ? "is-live" : "is-paused"}`}>
                            <div className={`vr-orb ${isLive ? "is-live" : ""}`} role="img" aria-label="Voice-Recorder-Frequency">
                                <Icon icon="lucide:audio-lines" width={48} height={48} />
                            </div>
                            <div className="vr-rec-legacy-timer">
                                {/* {recordNew ? formatTime(elapsedTime) : ""} */}
                                <span>

                                    {/* {recordingStart ? formatTime(elapsedTime) : ""} */}
                                    {recordNew
                                        ? `${formatTime(elapsedTime)}${!user?.isSubscriptionActive || !user ? " / 05:00" : ""}`
                                        : ""}
                                </span>
                            </div>
                            <div>
                                <div className="d-flex vr-rec-legacy-controls">
                                    {
                                        !btntoggl ? <div className="vr-rec-lbtn is-secondary" style={{ marginTop: recordNew ? "4px" : "95px" }}>
                                            <PlayButton
                                                click={() => {
                                                    if (!load) {

                                                        setBtnToggl(true); pauseRecording()
                                                    }
                                                }
                                                }
                                                src={"/img/button/push.png"}
                                                btnText={"Pause"}
                                                border

                                            />
                                        </div> : <div className="vr-rec-lbtn is-secondary" style={{ marginTop: recordNew ? "4px" : "95px" }}>
                                            <PlayButton
                                                click={() => {
                                                    if (!load) {
                                                        setBtnToggl(false); pauseRecording()
                                                    }
                                                }}

                                                src={"/img/button/Vector.png"}
                                                btnText={"Start"}
                                                border
                                            />
                                        </div>
                                    }

                                    <div className={`vr-rec-lbtn is-primary${load ? " is-loading" : ""}`} style={{ marginTop: recordNew ? "4px" : "95px" }}>
                                        <PlayButton
                                            click={(e) => {
                                                if (elapsedTime >= 1) {
                                                    setRecordNew(true);
                                                    stopRecording();
                                                    // setBtnToggl(false)
                                                    setLoading(true)
                                                    
                                                }
                                            }
                                            }
                                            src={load ? "" : "/img/button/stop.png"}
                                            btnText={load ? (
                                                <div
                                                    className="spinner-border"
                                                    role="status"
                                                    style={{ width: "1.3rem", height: "1.3rem" }}
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : "Stop"}
                                        />
                                    </div>

                                </div>
                            </div>

                            <RecordingNote
                                value={note}
                                onChange={onNoteChange}
                                disabled={load}
                            />
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Record